import type { DynamicFieldFormula, FieldVisitor, FormulaVisitor } from '../types.tsx';
import { EXPRESSION_TEMPLATE } from './types.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { EXPRESSION_TEMPLATE };

export const expressionVisitFields = (
	formula: DynamicFieldFormula,
	visitField: FieldVisitor,
	visitFormula: FormulaVisitor,
): boolean => {
	if (formula.template !== EXPRESSION_TEMPLATE) {
		return false;
	}
	visitFormula(formula.parameters.formula);
	return true;
};
